import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import styles from './styles.css.js';

/**
 * For Buttons with complex content (i.e. not just a string), we wrap each text node in a <span>
 * This allows us to style the children with accessors like :last-child
 */

var wrapChildTextNodesInSpans = function wrapChildTextNodesInSpans(children) {
  return React.Children.map(children, function (child) {
    if (typeof child === 'string') {
      return React.createElement("span", null, child);
    } else {
      return child;
    }
  });
};

var Button = function Button(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c,
      disabled = _a.disabled,
      testId = _a.testId,
      className = _a.className,
      children = _a.children,
      rest = __rest(_a, ["variant", "size", "disabled", "testId", "className", "children"]);

  var classes = classnames(styles[variant], styles[size], className);
  return React.createElement("button", __assign({
    className: classes,
    disabled: disabled,
    "data-testid": testId
  }, rest), React.Children.count(children) > 1 ? wrapChildTextNodesInSpans(children) : children);
};

export default Button;
//# sourceMappingURL=index.js.map
